export default {
    submission: 'ثبت با خطا مواجه شد',
    permissionDenied: 'خطای دسترسی',
    YouDontHavePermission: 'متاسفانه شما دسترسی موردنظر را ندارید.',
    BackToHome: 'بازگشت به صفحه‌ی اصلی'
}